import React, { useCallback, useEffect, useState } from "react";
import useAuthUser from "../../base/helper/useAuthUser";
import { error, info, success } from "../../../../store/notification/actions";
import { format } from "date-fns";
import CustomModal from "../../InventoryManagement/PhysicalInventory/views/CustomModal";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { PRIMARY_COLOR } from "../../../constants/baseConstants";
import MaterialTable from "material-table";
import axiosInstance from "../../../../axiosInstance";

function PIMissingPriceItems({ date, handleClose }) {
  const { storeId } = useAuthUser();
  const [productsWithoutPrice, setProductsWithoutPrice] = useState([]);

  const getProductsWithoutPrice = useCallback(
    async (options) => {
      info("Checking Prices...");
      if (!storeId || !date) return;
      try {
        const result = await axiosInstance.post(
          "/physicalInventory/getPIItemsWithoutPriceCurrent",
          {
            storeId,
            date: format(date, "MM-dd-yyyy"),
          },
          {
            signal: options.signal,
          }
        );
        if (result.data.data) setProductsWithoutPrice(result.data.data);
        if (result.data.data.length < 1)
          success("There are no products here with missing prices");
        else success(result.data.data.length + " products found");
      } catch (err) {
        if (err.message === "canceled") return;
        error(
          (err.response?.data?.error && err.response.data.error[0]?.message) ||
            err.message
        );
      }
    },
    [storeId, date]
  );

  useEffect(() => {
    const controller = new AbortController();
    getProductsWithoutPrice({ signal: controller.signal });

    return () => controller.abort();
  }, [getProductsWithoutPrice]);

  const showProductListPopup = date !== null && productsWithoutPrice.length > 0;

  return (
    <>
      <CustomModal open={showProductListPopup} onClose={handleClose}>
        <Box style={{ padding: 10, width: "100%" }}>
          <Box
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              padding: 5,
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">
              Missing Prices{" "}
              <Tooltip title="Price was not found for the following items">
                <IconButton style={{ height: 15, width: 15 }}>
                  <InfoOutlined />
                </IconButton>
              </Tooltip>
            </Typography>
            <Button
              onClick={handleClose}
              variant="contained"
              size="medium"
              style={{
                backgroundColor: PRIMARY_COLOR,
                borderRadius: "0.5rem",
                color: "white",
              }}
            >
              Close
            </Button>
          </Box>

          <MaterialTable
            title={"Missing Price Products " + format(date, "MM-dd-yyyy")}
            style={{ height: "80vh", overflow: "scroll", width: "100%" }}
            columns={[
              { title: "NDC", field: "ndc" },
              { title: "Generic Name", field: "generic_name" },
              { title: "Description", field: "description" },
              {
                title: "Manufacturer",
                field: "manufacturer",
                render: (row) => {
                  return row.manufacturer
                    ?.map((m) => m.toUpperCase())
                    ?.join(", ");
                },
              },
              { title: "Pack size", field: "pack_size_quantity" },
            ]}
            data={productsWithoutPrice}
            options={{
              exportButton: true,
              exportAllData: true,
              pageSize: 50,
              pageSizeOptions: [25, 50, 100, 250, 500],
            }}
          />
        </Box>
      </CustomModal>
    </>
  );
}

export default PIMissingPriceItems;
